<template>
    <section class="page-manage container">
        <BaseButtonBack></BaseButtonBack>

        <SchemaTreeContainer
          class="page-manage__tree"
          :value="schema"
          :scope="scope"
        ></SchemaTreeContainer>
        <br/>
        <br/>
        <BaseButton class="page-manage__save-btn" theme="primary" @click.native="save" title="Save" :loading="loading"></BaseButton>

        <BaseHelpButton
          v-if="linkScope"
          text="View your"
          icon="help"
          :linkAction="linkAction"
          :linkLabel="`${linkScope}.`"/>
    </section>
</template>

<script>
import Store from '@/stores'
import { windowConfirm } from '@/helpers'
import SchemaChangeDetector from '@/plugins/schema-change-detector'
import SchemaTreeContainer from '@/components/SchemaTreeContainer'

export default {
    components: {
        SchemaTreeContainer
    },

    data() {
        return {
            store: this.$route.meta.store,
            scope: this.$route.meta.scope,
            loading: false
        }
    },

    computed: {
        linkScope() {
            let _scope

            switch (this.scope) {
                case 'shop':
                    _scope = null
                    break
                case 'variants':
                    _scope = 'products'
                    break
                default:
                    _scope = this.scope
            }

            return _scope
        },
        schema: {
            get() {
                return { ...this.$store.getters[`${this.store}/schema`] }
            }
            // set (schema) {
            //     this.$store.commit(`${this.store}/SET_SCHEMA`, { schema })
            // }
        }
    },
    methods: {
        async save() {
            this.$store.commit(`${this.store}/MAP_AND_SET_SCHEMA`, { schema: this.schema })
            try {
                this.loading = true
                await this.$store.dispatch(`${this.store}/SAVE_SCHEMA`)

                this.$store.commit('banners/SHOW_BANNER', {
                    status: 'success',
                    title: 'Fields saved.'
                })
                this.$eventBus.$emit('AFTER_SAVE_SCHEMA')
            } catch (e) {
                this.$store.commit('banners/SHOW_BANNER', {
                    status: 'warning',
                    title: 'Fields save failed.'
                })
            } finally {
                this.loading = false
            }
        },

        async handleWidnowEvent(e) {
            await this.save()
        },

        linkAction() {
            if (!window.shopify) {
                return console.error('window.shopify is not available')
            }
            // Use new App Bridge navigation API
            // Migration guide line 488: Redirect.Action.APP -> shopify.navigation.navigate()
            window.shopify.navigation.navigate(`/admin/${this.linkScope}`)
        }
    },

    async beforeRouteEnter(to, from, next) {
        try {
            if (to.query.id) {
                Store.commit(`${to.meta.store}/SET_ID`, { id: to.query.id })
            }
            await Store.dispatch(`${to.meta.store}/GET_SCHEMA_METAFIELD`)
            next()
        } catch (error) {
            console.error(`Couldn't resolve ${to.name} beforeRouteEnter requests`, { error })
            next({
                name: 'app.error',
                query: { type: 'API' }
            })
        }
    },

    beforeRouteLeave(to, from, next) {
        const stay = () => {
            next(false)
        }

        if (new SchemaChangeDetector().areChangesUnsaved) {
            const answer = windowConfirm(this.$translations['UNSAVED_CHANGES_MESSAGE'])

            if (answer) {
                next()
            } else {
                stay()
            }
        } else {
            next()
        }
    },

    mounted() {
        window.addEventListener('save', this.handleWidnowEvent, false)
    },

    beforeDestroy() {
        window.removeEventListener('save', this.handleWidnowEvent)
        this.$store.commit('banners/CLOSE_BANNER')
    }
}
</script>

<style lang="scss">
@import './src/assets/styles/grid.scss';
@import './src/assets/styles/breakpoints.scss';

.page-manage {
    &__tree {
        @include media(ltMobile) {
            margin-left: -$container-gutter-mobile;
            margin-right: -$container-gutter-mobile;
        }
    }

    .page-manage__save-btn {
        display: flex;
        margin-left: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/page-manage.vue